import * as React from 'react';

import FromFile from '../../containers/PublicationCreator/FromFile';
import FromTemplate from '../../containers/PublicationCreator/FromTemplate';

interface PublicationCreatorProps {
	isDisplayed: boolean;
	isFromFile: boolean;
}

const PublicationCreator = ({ isDisplayed, isFromFile }: PublicationCreatorProps) => (
	<>
		<FromFile isDisplayed={isFromFile && isDisplayed} />
		<FromTemplate isDisplayed={!isFromFile && isDisplayed} />
	</>
);

export default PublicationCreator;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PublicationCreator/index.tsx